import React, { useEffect, useState, useRef } from 'react';
import './ideas_busq.css'
import { useTranslation } from 'react-i18next';
import Modal2 from '../../../components/modal/Modal';

const Ideas_busq = ({ contenido }) => {
    const [t, i18n] = useTranslation("ideaCorta");

    const verYoutu = (ruta) => {
        window.open(ruta, '_blank');

    }
    const clase = (index) => {
            return "card"
    };

    const renderizarMensaje = (tipo, contenido, preview, index) => {
        if (index === 0 || index < 3 || index > 4) {
            if (tipo === "texto") {
                return (
                    <div className="text1">
                        <div className='mensageDiv' dangerouslySetInnerHTML={{ __html: contenido }} ></div>
                    </div>
                )
                    ;
            }
            else if (tipo === "imagen") {
                return <div className='card-type-img'>
                    <img className="img1" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                </div>
                    ;
            }
            else if (tipo === "texto-video") {
                return <div className='imageTxtContainer'>
                    <div className='playImageContainerMobile' onClick={() => openModal2(contenido, "", preview)}>
                        <div className='arrow-right' />
                    </div>
                    <button onClick={() => openModal2(contenido, '', preview)}>
                        {/* <img className="img1 img_text_vid_grand " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" /> */}
                        <img className="img1 img_text_vide " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>

                </div>
                    ;
            }
            else if (tipo === "texto-imagen") {
                // return <div>
                return <>
                    <button onClick={() => openModal2(contenido, '', preview)}>
                        
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    <div className="cinta" onClick={() => openModal2(contenido, '', preview)}>
                        <p className="tit_LB">Leer blog</p>
                    </div>
                    {/* </div> */}
                </>
                    ;
            }
            else if (tipo === "carrete") {
                return <div>


                    <button className="boton_Lin2" onClick={() => openModal2(contenido, 'carrete', preview)}>
                        <img className="img_carrete " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    <div className="cinta" onClick={() => openModal2(contenido, 'carrete', preview)}>
                        <p className="tit_LB">Ver galería</p>
                    </div>

                </div>
                    ;
            }
            else if (tipo === "youtube") {
                return <div className='div-youtube-list'>
                    {/* <button onClick={() => openModal2(contenido, '')}> */}
                    <button onClick={() => verYoutu(contenido)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />

                    </button>
                </div>
                    ;
            }
            else if (tipo === "video") {
                return <div className='div-youtube-list'>
                    {/* <button onClick={() => openModal2(contenido, '')}>  esta es la linea originall que tenia*/}
                    <button onClick={() => verYoutu(contenido)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />

                    </button>

                </div>
                    ;
            }
            else {
                return <p>La condición es falsa que  tipo eres-----: {tipo}</p>;
            }
        }
        else if (index === 3 || index === 4) {
            if (tipo === "texto") {
                return <div className="div_mayor">
                    <div className="text1">
                        <div className="mensageDiv" dangerouslySetInnerHTML={{ __html: contenido }} />
                    </div>
                </div>
                    ;
            }
            else if (tipo === "imagen") {
                return <div className="div_mayor card-type-img">
                    <img className="img1" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                </div>
                    ;
            }
            else if (tipo === "texto-imagen") {

                return <div className="div_mayor">
                    <button className="boton_Lin2" onClick={() => openModal2(contenido, '', preview)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    <div className="cinta" onClick={() => openModal2(contenido, '', preview)}>
                        <p className="tit_LB">Leer blog</p>
                    </div>
                </div>
                    ;
            }
            else if (tipo === "texto-video") {

                return <div className="div_mayor">
                    <button className="boton_Lin2" onClick={() => openModal2(contenido, '', preview)}>
                        <div className='playImageContainer' >
                            <div className='arrow-right' />
                        </div>
                        <img className="img1 img_text_vid_grand " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>


                </div>
                    ;
            }
            else if (tipo === "carrete") {
                return <div>
                    <button className="boton_Lin2" onClick={() => openModal2(contenido, 'carrete', preview)}>
                        <img className="img_carrete " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    <div className="cinta" onClick={() => openModal2(contenido, 'carrete', preview)}>
                        <p className="tit_LB">Ver galería</p>
                    </div>

                </div>
                    ;
            }
            else if (tipo === "youtube") {
                return <div className='div-youtube-list'>
                    {/* <button onClick={() => openModal2(contenido, '')}> */}
                    <button onClick={() => verYoutu(contenido)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                </div>
                    ;
            }
            else if (tipo === "video") {
                return <div className='div-youtube-list'>
                    <button onClick={() => openModal2(contenido, '', preview)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                </div>
                    ;
            }
            else {
                return <div class="div_mayor"> <p> que  tipo eres-----: {tipo}</p>;</div>
            }
        }
    };

    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [variable1, setVariable1] = useState('');
    const [variable2, setVariable2] = useState('');

    const openModal2 = (value1, value2, value3) => {

        setVariable1(value1);
        setVariable2(value2);
        setIsModalOpen2(true);
        navigator.clipboard.writeText(`${window.location.origin}/${i18n.language}/Ideas-en-Corto${value3}`).then(() => { console.log("copied") });
    };

    const closeModal2 = () => {
        setVariable1('');
        setVariable2('');
        setIsModalOpen2(false);
    };

    if (!contenido || !contenido.ideas || contenido.ideas.length === 0) {
        // Handle the case where `contenido` or `blogNs` is not available or is an empty array.
        return <div></div>;
      }

        return (
            <div id="bus_ideas" className='ideas_busq ideas-cort'>
                <div className='titulo_div'>
                <p className='tit1'>{t("ideaCort.tit1")} <span className='tit2'>{t("ideaCort.tit2")}</span></p>
                </div>
                <div class="row2_LB escritorio_idCorTod">
                    <div class="list_content--items">
                        {
                            contenido.ideas.map((item, index) => (

                                <div class={clase(index)}>

                                    <div className='div-card-1'>
                                        {renderizarMensaje(item.tipo, item.contenido, item.preview, index)}
                                    </div>
                                </div>

                            ))
                        }

                    </div>

            </div>

            <Modal2
                isOpen={isModalOpen2}
                closeModal={closeModal2}
                variable1={variable1}
                variable2={variable2}
            />
            </div>
        );
    
}

export default Ideas_busq;